import React from "react";
import { Alert, Typography } from "@mui/material";
import type { VideoAttachmentLike } from "../../utils/videoAttachment";
import { getVideoProcessingAttachments } from "../../utils/videoAttachment";

type VideoProcessingAlertProps = {
  attachments?: VideoAttachmentLike[] | null;
  sx?: object;
};

export const VideoProcessingAlert: React.FC<VideoProcessingAlertProps> = ({
  attachments,
  sx,
}) => {
  const processing = getVideoProcessingAttachments(attachments);
  if (processing.length === 0) {
    return null;
  }

  const firstName = processing[0]?.name || "Video";

  return (
    <Alert severity="info" sx={{ mb: 2, ...sx }}>
      <Typography variant="body2" component="div">
        {processing.length === 1 ? (
          <>
            <strong>{firstName}</strong> is still processing. Optimized playback
            is usually ready within a few minutes — refresh this page to check.
          </>
        ) : (
          <>
            <strong>{processing.length} videos</strong> are still processing.
            Optimized playback is usually ready within a few minutes — refresh
            this page to check.
          </>
        )}
      </Typography>
    </Alert>
  );
};

export default VideoProcessingAlert;
